import { Injectable } from '@angular/core'; 

@Injectable()
export class BrowserStorageService {
    static readonly SESSION_SCOPE: number = 0;
    static readonly LOCAL_SCOPE: number = 1;

    public set(key: string, value: string, storageScope: number = BrowserStorageService.LOCAL_SCOPE): any {
        if (storageScope == BrowserStorageService.SESSION_SCOPE) {
            sessionStorage.setItem(key, value);
        } else {
            localStorage.setItem(key, value);
        }
    }

    /** Returns the string value from the indicated store, or null if the key does not exist. */
    public get(key: string, storageScope: number = BrowserStorageService.LOCAL_SCOPE): any {
        if (storageScope == BrowserStorageService.SESSION_SCOPE) {
            return sessionStorage.getItem(key);
        } else {
            return localStorage.getItem(key);
        }
    }

    public delete(key: string, storageScope: number = BrowserStorageService.LOCAL_SCOPE): void {
        if (storageScope == BrowserStorageService.SESSION_SCOPE) {
            sessionStorage.removeItem(key);
        } else {
            localStorage.removeItem(key);
        }
    }

    // Convenience methods

    // The following two methods added for VNEXT-1696 (previous and next buttons on a Form)
    // See https://community-dc.max.gov/x/wAdao
    public setFormInstanceIdsForFormsGrid(formTemplateId: number, formInstanceIds: number[]): void {
        this.set(`formInstanceIdsForFormsGrid${formTemplateId}`, formInstanceIds.join(','), BrowserStorageService.SESSION_SCOPE);
    }
    public getFormInstanceIdsForFormsGrid(formTemplateId: string): number[] {
        const idsAsString = this.get(`formInstanceIdsForFormsGrid${formTemplateId}`, BrowserStorageService.SESSION_SCOPE);
        if (idsAsString)
            return idsAsString.split(',').map(x => { return parseInt(x) });
        else
            return [];
    }

}
